/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_Art_BodyInputs */

const en_services_svc_save_art_body = /** @type {(inputs: Services_Svc_Save_Art_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first consultation covers your goals, the current process and possible next steps. A proposal follows if there’s a useful fit.`)
};

const lv_services_svc_save_art_body = /** @type {(inputs: Services_Svc_Save_Art_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirmajā konsultācijā pārrunājam Jūsu mērķus, esošo procesu un iespējamos nākamos soļus. Ja redzam, kā varētu palīdzēt, sagatavojam piedāvājumu.`)
};

/**
* | output |
* | --- |
* | "The first consultation covers your goals, the current process and possible next steps. A proposal follows if there’s a useful fit." |
*
* @param {Services_Svc_Save_Art_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_art_body = /** @type {((inputs?: Services_Svc_Save_Art_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_Art_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_art_body(inputs)
	return en_services_svc_save_art_body(inputs)
});